import wx from 'weixin-js-sdk';
import { defineStore } from 'pinia';
import { browerVersion } from '../../utils';

const defaultShareTitle = import.meta.env.VITE_WECHAT_SHARE_TITLE;
const defaultShareDesc = import.meta.env.VITE_WECHAT_SHARE_DESC;
const defaultShareLogo = import.meta.env.VITE_DEFAULT_SHARE_IMAGE;
/**
 * 分享参数的整理合并
 * @param params
 * @returns
 */
const mergeShareParams = (params: ShareParams) => ({
  title: params.title || defaultShareTitle,
  desc: params.desc || defaultShareDesc,
  link: params.link || window.location.href,
  imgUrl: params.imgUrl || defaultShareLogo,
});

/**
 * 检查JsApi是否可用
 * @param value
 * @returns
 */
const checkJsApiResult = (value: string | boolean) => value === 'true' || value === true;

/**
 * 更新微信分享信息
 * @param shareParams
 */
const updateShareParams = (shareParams: ShareParams) => {
  const { title, desc, link, imgUrl } = shareParams;
  const shareAppMessage = {
    title: title || defaultShareTitle,
    desc: desc || defaultShareDesc,
    link: link || window.location.href,
    imgUrl: imgUrl || defaultShareLogo,
    success: () => {},
  };
  const shareTimelineMessage = {
    title: title || defaultShareTitle,
    link: link || window.location.href,
    imgUrl: imgUrl || defaultShareLogo,
    success: () => {},
  };
  wx.checkJsApi({
    jsApiList: [
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'onMenuShareAppMessage',
      'onMenuShareTimeline',
    ],
    success: (res: any) => {
      if (!res || !res.checkResult) {
        wx.updateAppMessageShareData(shareAppMessage);
        wx.updateTimelineShareData(shareTimelineMessage);
        return;
      }
      const {
        updateAppMessageShareData,
        onMenuShareAppMessage,
        updateTimelineShareData,
        onMenuShareTimeline,
      } = res.checkResult;
      if (checkJsApiResult(updateAppMessageShareData)) {
        wx.updateAppMessageShareData(shareAppMessage);
      } else if (checkJsApiResult(onMenuShareAppMessage)) {
        wx.onMenuShareAppMessage({ ...shareAppMessage, cancel: () => {} });
      }
      if (checkJsApiResult(updateTimelineShareData)) {
        wx.updateTimelineShareData(shareTimelineMessage);
      } else if (checkJsApiResult(onMenuShareTimeline)) {
        wx.onMenuShareTimeline({ ...shareTimelineMessage, cancel: () => {} });
      }
    },
    fail: (err: any) => {
      console.error(err);
      wx.updateAppMessageShareData(shareAppMessage);
      wx.updateTimelineShareData(shareTimelineMessage);
    },
  });
};

const useWxShareStore = defineStore('wxShare', {
  state: () => {
    return {
      isFetching: false,
      isWxReady: false,
      shareParams: {
        title: '',
        desc: '',
        link: '',
        imgUrl: '',
      },
    };
  },
  actions: {
    async initWxShare(params?: ShareParams) {
      if (!browerVersion().weixin) {
        return;
      }
      if (params) {
        this.shareParams = mergeShareParams(params);
      }
      if (this.isWxReady) {
        updateShareParams(this.shareParams);
      }
      if (!this.isFetching) {
        this.isFetching = true;
        const url = window.location.href.split('#')[0];
        const res = await fetch(
          `${import.meta.env.VITE_RMT_DOMAIN}/auxiliaryapi/api/content/wxShare/wechatParam?url=${encodeURIComponent(url)}`,
        );
        const data = await res.json();
        wx.config({
          appId: data.appid,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
          ],
          openTagList: ['wx-open-launch-app'],
        });
        wx.ready(() => {
          this.isWxReady = true;
          updateShareParams(this.shareParams);
        });
      }
    },
  },
});

export default useWxShareStore;
